<script lang="ts">
import SuperAdminLayout from "@/layouts/SuperAdminLayout.vue"

export default { layout: SuperAdminLayout }
</script>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3"
import { SbList, SbListItem, SbListLabel, SbListSection } from "@unio/saltbox-ui"

import FlashAlerts from "@/components/FlashAlerts.vue"
import { ICON } from "@/lib/icons"
import { newSuperAdminUserPath, superAdminUserPath } from "@/routes"

export interface UserEntry {
  id: string
  full_name: string
  email_address: string
  initials: string
  avatar_url: string | null
  super_admin: boolean
  active: boolean
}

defineProps<{
  users: UserEntry[]
}>()
</script>

<template>
  <Head title="Users — Admin" />

  <div class="flex flex-col gap-6">
    <FlashAlerts />

    <div class="flex justify-end">
      <UButton
        :icon="ICON.add"
        label="New"
        color="neutral"
        variant="subtle"
        size="sm"
        :to="newSuperAdminUserPath()"
      />
    </div>

    <SbList v-if="users.length" bordered separator>
      <SbListItem v-for="user in users" :key="user.id" :to="superAdminUserPath(user.id)">
        <SbListSection avatar>
          <UAvatar
            :src="user.avatar_url ?? undefined"
            :text="user.initials"
            :alt="user.full_name"
            size="sm"
          />
        </SbListSection>
        <SbListSection>
          <SbListLabel :class="{ 'text-muted': !user.active }">
            {{ user.full_name }}
          </SbListLabel>
          <SbListLabel caption>{{ user.email_address }}</SbListLabel>
        </SbListSection>
        <SbListSection side>
          <div class="flex items-center gap-2">
            <UBadge v-if="!user.active" color="neutral" variant="outline">Deactivated</UBadge>
            <UBadge v-if="user.super_admin" color="primary" variant="subtle">Admin</UBadge>
          </div>
        </SbListSection>
      </SbListItem>
    </SbList>

    <p v-else class="text-muted py-12 text-center text-sm">No users yet.</p>
  </div>
</template>
